<body>
  <div class="content">
    <h2>You are not authorized to view this page.</h2>
  </div>
</body>
